import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  background-color: black;
  opacity: 0.6;
  color: white;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999999;
`;
